import {Config} from './config';

async function request(prefix, params = {}, data) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
        const response = await fetch(`${Config.apiUrl}${prefix}/?${new URLSearchParams(params)}`, {
            method: data === undefined ? 'GET' : 'POST',
            headers: {
                Authorization: Config.tgWindow.initData || '',
                'Content-Type': 'application/json',
                'ngrok-skip-browser-warning': 'Any',
                ...(data !== undefined ? {platform: Config.tgWindow.platform || 'unknown'} : {}),
            },
            ...(data !== undefined ? {body: JSON.stringify(data)} : {}),
            signal: controller.signal,
        });
        return response;
    } catch (error) {
        throw new Error(error.name === 'AbortError' ? 'Сервер не ответил вовремя. Попробуйте ещё раз.' : 'Не удалось связаться с сервером. Проверьте подключение к интернету.');
    } finally {
        clearTimeout(timeout);
    }
}
export async function getApiRequest(prefix, params = {}) {
    const response = await request(prefix, params);
    const result = await response.json();
    if (!response.ok && !result.error && !result.detail) throw new Error('Не удалось загрузить данные. Попробуйте ещё раз.');
    return result;
}
export const postApiRequest = (prefix, params = {}, data = {}) => request(prefix, params, data);
